import utils from "../utils";
import Splide from '@splidejs/splide';

function initNumberedCarousel() {
	const numbers = document.querySelectorAll('.number');
	const carousel_element = document.querySelector('.numbered-carousel--carousel');

	

	if (carousel_element) {

		const carousel = new Splide(carousel_element, {
			type: 'loop',
			pagination: false,
			speed: 1000,
			autoplay: true,
			rewind: true,
			// arrows: navigation,
			updateOnMove: true,
			// perMove: 1,
			rewindByDrag: false,
			// direction: directionValue,
			arrowPath: "m30.98,29.02l-1.23-1.24,6.91-6.91H0v-1.75h36.65l-6.9-6.91,1.23-1.23,9.02,9.02-9.02,9.02Z",
			classes: {
				// Add classes for arrows.
				arrows: "smx-navigation",
				arrow: "smx-nav magic-hover",
				prev: "prev carousel-prev",
				next: "next carousel-next",
				pagination: "smx-pagination",
				page: "smx-dot",
			},
		});


		carousel.on('move', function(newIndex){
			var number = document.getElementById('number-' + newIndex);
			numbersRotation(number);
		});

		

		if (numbers.length > 0) {

			utils.forEach(numbers, function (index, number) {
				number.addEventListener('click', function () {
					numbersRotation(number);
					carousel.go(index);

				});
			});
	
	
		}

		carousel.mount();

		


	}
}







function numbersRotation(number) {
	const numbers_container = document.querySelector('.numbers-container'),
		default_rotation = -90,
		step_increase = 30,
		numbers = document.querySelectorAll('.number');


	var number_index = number.dataset.numberindex;
	// var number_index = number.getAttribute( 'data-numberindex' );
	var rotation = default_rotation + (step_increase * number_index);
	numbers_container.style.transform = 'rotate(' + rotation + 'deg)';
	utils.forEach(numbers, function (index2, number2) {
		number2.classList.remove('active');
		number2.style.transform = "translateX(-50%) translateY(-50%) rotate(" + (rotation * -1) + "deg)";
	});
	number.classList.add('active');

}

export default { initNumberedCarousel }